import {
  GuaranteesFetchStatus,
  TGuaranteesAsyncSlice,
  TGuaranteesPageStore,
  TGuaranteesThunkError,
} from '../types.ts';
import { initialState } from '../initialState.ts';

export const setGuaranteesPendingAction = <T>(slice: TGuaranteesAsyncSlice<T>) => {
  slice.status = GuaranteesFetchStatus.Loading;
  slice.error = null;
};

export const setGuaranteesFulfilledAction = <T>(slice: TGuaranteesAsyncSlice<T>, data: T) => {
  slice.status = GuaranteesFetchStatus.Success;
  slice.data = data;
  slice.error = null;
};

export const setGuaranteesRejectedAction = <T>(slice: TGuaranteesAsyncSlice<T>, error: unknown) => {
  slice.status = GuaranteesFetchStatus.Error;
  slice.error = (error as TGuaranteesThunkError) ?? { message: 'Помилка запиту' };
};

export const resetGuaranteesApplicationsAction = (state: TGuaranteesPageStore) => {
  state.applications = initialState.applications;
  state.applicationTimeline = initialState.applicationTimeline;
  state.createApplication = initialState.createApplication;
  state.currentApplication = initialState.currentApplication;
  state.patchRootApplicationSection = initialState.patchRootApplicationSection;
  state.principal = initialState.principal;
  state.patchPrincipal = initialState.patchPrincipal;
  state.beneficiary = initialState.beneficiary;
  state.patchBeneficiary = initialState.patchBeneficiary;
  state.patchApplicationTender = initialState.patchApplicationTender;
  state.applicationTenderInfo = initialState.applicationTenderInfo;
  state.fetchProzorroTender = initialState.fetchProzorroTender;
  state.patchApplicationMainDeal = initialState.patchApplicationMainDeal;
  state.patchApplicationSecret = initialState.patchApplicationSecret;
  state.checkApplicationRequest = initialState.checkApplicationRequest;
  state.managerSupervisorInfo = initialState.managerSupervisorInfo;
  state.uakdoSupervisorInfo = initialState.uakdoSupervisorInfo;
  state.administrationSupervisorInfoByPage = initialState.administrationSupervisorInfoByPage;
  state.managerTasks = initialState.managerTasks;
  state.updateApplicationStatus = initialState.updateApplicationStatus;
  state.supervisorSegmentsByGroup = initialState.supervisorSegmentsByGroup;
};
